import { Attachment, S3Attachment } from '../../../types';
import { AttachmentRowTemplate } from './AttachmentRowTemplate';

export interface AttachmentRowProps {
  attachment: Attachment | S3Attachment;
  cancelUpload: (attachmentId: string) => void;
  retryUpload: (attachmentId: string) => void;
  removeAttachment?: (attachmentId: string) => void;
  showProgressPercentage?: boolean;
}

export function AttachmentRow({
  attachment,
  retryUpload,
  cancelUpload,
  removeAttachment,
  showProgressPercentage
}: AttachmentRowProps) {
  switch (attachment.status) {
    case 'queued':
      return (
        <AttachmentRowTemplate
          id={attachment.id}
          statusIcon="greyCheckmark"
          fileName={attachment.file.name}
          statusMessage={removeAttachment ? 'ready to upload' : 'queued'}
          handleAttachmentIcon={removeAttachment ? 'trash' : 'retry'}
          handleAttachmentOnClick={removeAttachment ?? retryUpload}
        />
      );
    case 'uploading':
      return (
        <AttachmentRowTemplate
          id={attachment.id}
          statusIcon="greyCheckmark"
          fileName={attachment.file.name}
          statusMessage="uploading"
          progress={attachment.progress}
          showProgressPercentage={showProgressPercentage}
          handleAttachmentIcon="cancel"
          handleAttachmentOnClick={cancelUpload}
        />
      );
    case 'success':
      return (
        <AttachmentRowTemplate
          id={attachment.id}
          statusIcon="greenCheckmark"
          fileName={attachment.file.name}
          statusMessage="attached successfully"
        />
      );
    case 'limited':
      return (
        <AttachmentRowTemplate
          id={attachment.id}
          statusIcon="alert"
          fileName={attachment.file.name}
          statusMessage="— this file exceeds our 100MB size limit"
          handleAttachmentIcon={removeAttachment ? 'trash' : 'cancel'}
          handleAttachmentOnClick={removeAttachment ?? cancelUpload}
        />
      );
    case 'unsupported':
      return (
        <AttachmentRowTemplate
          id={attachment.id}
          statusIcon="alert"
          fileName={attachment.file.name}
          statusMessage="— this file type is not supported"
          handleAttachmentIcon={removeAttachment ? 'trash' : 'cancel'}
          handleAttachmentOnClick={removeAttachment ?? cancelUpload}
        />
      );
    case 'canceled':
      return (
        <AttachmentRowTemplate
          id={attachment.id}
          statusIcon="alert"
          fileName={attachment.file.name}
          statusMessage="— this file upload was canceled"
          handleAttachmentIcon="retry"
          handleAttachmentOnClick={retryUpload}
        />
      );
    default:
      return (
        <AttachmentRowTemplate
          id={attachment.id}
          statusIcon="alert"
          fileName={attachment.file.name}
          statusMessage="— something went wrong on our end."
          handleAttachmentIcon={removeAttachment ? 'trash' : 'retry'}
          handleAttachmentOnClick={removeAttachment ?? retryUpload}
        />
      );
  }
}
